import { IH2OTheme } from '@h2oai/ui-kit';

const TRUSTED_ROLES_OCCUPIED_HEIGHT = 450;

export const trustedRolesListRoot = (theme: IH2OTheme) => ({
  padding: '24px',
  backgroundColor: theme.palette?.gray200,
  borderRadius: '8px',
  border: `1px solid ${theme.palette?.gray300}`,
  maxHeight: `calc(100vh - ${TRUSTED_ROLES_OCCUPIED_HEIGHT}px)`,
  overflowY: 'auto' as const,
  display: 'flex',
  flexDirection: 'column' as const,
});

export const trustedRolesItemsContainer = () => ({
  maxHeight: `calc(100vh - ${TRUSTED_ROLES_OCCUPIED_HEIGHT + 280}px)`,
  overflowY: 'auto' as const,
  flex: '1 1 auto',
});

export const roleArnDisplayStyles = (theme: IH2OTheme) => ({
  padding: '12px 16px',
  backgroundColor: theme.palette?.gray200,
  borderRadius: '4px',
  marginBottom: '16px',
  border: `1px solid ${theme.palette?.gray300}`,
});

export const roleArnLabelStyles = (theme: IH2OTheme) => ({
  fontSize: '12px',
  color: theme.palette?.gray500,
  marginBottom: '4px',
  fontWeight: '600',
});

export const roleArnValueStyles = (theme: IH2OTheme) => ({
  fontSize: '14px',
  color: theme.palette?.gray750,
  fontFamily: 'monospace',
  wordBreak: 'break-all' as const,
});

export const trustedRolesHeaderStyles = () => ({
  marginBottom: '16px',
});

export const trustedRolesTitleStyles = (theme: IH2OTheme) => ({
  margin: 0,
  color: theme.palette?.gray750,
});

export const rolesListDescriptionStyles = (theme: IH2OTheme) => ({
  color: theme.palette?.gray500,
  margin: '8px 0 0 0',
  fontSize: '14px',
});
